import { AppleEmoji } from '../../components/AppleEmoji';

export default function KycView() {
  return (
    <div className="page-view">
      <div className="page-view__header">
        <h1 className="page-view__title">
          <AppleEmoji emoji="🆔" size={32} /> KYC верификация
        </h1>
        <p className="page-view__subtitle">
          Расширенная проверка личности через Sumsub.
        </p>
      </div>

      <div className="kyc-placeholder">
        <div className="kyc-placeholder__emoji">
          <AppleEmoji emoji="🧪" size={56} />
        </div>
        <div className="kyc-placeholder__title">Пока не требуется</div>
        <div className="kyc-placeholder__text">
          KYC-верификация через Sumsub сейчас <b>не требуется</b> для совершения покупок —
          достаточно подтверждённого email и телефона.
        </div>
        <div className="kyc-placeholder__badge">
          <AppleEmoji emoji="🔒" size={14} />
          <span>В разработке — появится в будущем для повышенных лимитов</span>
        </div>
      </div>
    </div>
  );
}
